// extracted by mini-css-extract-plugin
export default {"realTimeWinsTitleWrapper":"RealTimeWins_realTimeWinsTitleWrapper--Yac","displayNone":"RealTimeWins_displayNone--J5T"};